import { App } from 'antd';
import React, { ReactNode } from 'react';
import { CSSPixelsNumber } from '../../../../infrastructure/types/common/common-types';
import styled from 'styled-components';

interface ModalConfig {
  title?: ReactNode;
  content?: ReactNode;
  footer?: (modal) => ReactNode;
  width?: CSSPixelsNumber;
}

interface ModalActions {
  destroy: () => void;
}

function useModal() {
  const { modal } = App.useApp();

  const showModal = ({ title, footer, content, width }: ModalConfig) => {
    const modalInstance = modal.confirm({
      title: title,
      icon: <></>,
      closable: true,
      footer: () => footer && footer(modalInstance),
      content: content,
      centered: true,
      width: width,
    });
  };

  return { showModal };
}

export { useModal, type ModalActions };
